<template>
  <div class="subscription main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Dados da sua assinatura</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row :class="isDowngradingPlan() ? 'mb-1' : 'mb-3'" v-if="client != null && (client.subscription == null || client.subscription.status != 'ACTIVE')">
          <b-col>
            <div class="alert text-center" :class="{ 'alert-success': daysToEndTrial >= 6, 'alert-warning': daysToEndTrial <= 5 && daysToEndTrial >= 3, 'alert-danger': daysToEndTrial <= 2 }" role="alert">
              <p class="mb-0" v-if="daysToEndTrial >= 2 ">O seu período de teste está ativo e é válido até o dia {{ testUntil.format('DD/MM/YYYY') }}.</p>
              <p class="mb-0" v-else-if="daysToEndTrial == 1 || daysToEndTrial == 0">O seu período de teste está ativo e é válido até {{ (daysToEndTrial == 1)?'amanhã':'hoje' }}.</p>
              <p class="mb-0" v-else-if="daysToEndTrial < 0">O seu período do teste venceu há {{ (daysToEndTrial * -1) }} dia{{ Math.abs(daysToEndTrial) > 1?'s':'' }}. Assine agora para continuar usando!</p>
            </div>
          </b-col>
        </b-row>
        <b-row :class="isDowngradingPlan() ? 'mb-1' : 'mb-3'" v-else-if="client != null && client.subscription != null && client.subscription.status == 'ACTIVE'">
          <b-col>
            <div class="alert text-center" :class="{ 'alert-success': daysToEndSubscription >= 6 || automaticPaymentEnabled, 'alert-warning': daysToEndSubscription <= 5 && daysToEndSubscription >= 3 && !automaticPaymentEnabled, 'alert-danger': daysToEndSubscription <= 2 && !automaticPaymentEnabled }" role="alert">
              <p class="mb-0" v-if="daysToEndSubscription >= 2">A sua assinatura do plano {{currentPlan.name}} está ativa e {{ automaticPaymentEnabled ? 'será renovada no' : 'é valida até o' }} dia {{ subscriptionValidUntil.format('DD/MM/YYYY') }}.</p>
              <p class="mb-0" v-else-if="daysToEndSubscription == 1 || daysToEndSubscription == 0">A sua assinatura do plano {{currentPlan.name}} está ativa e {{ automaticPaymentEnabled ? 'será renovada' : 'é valida até' }} {{ (daysToEndSubscription == 1)?'amanhã':'hoje' }}.</p>
              <p class="mb-0" v-else-if="daysToEndSubscription < 0">A sua assinatura do plano {{currentPlan.name}} venceu há {{ (daysToEndSubscription * -1) }} dia{{ Math.abs(daysToEndSubscription) > 1?'s':'' }}. Realize o pagamento para {{client.status == 'SUSPENDED' ? 'reativar' : 'não perder'}} o seu acesso.</p>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2" v-if="isDowngradingPlan()">
          <b-col>
            <div class="alert alert-secondary text-center" role="alert">
              <p class="mb-0" v-if="daysToEndSubscription >= 2">A sua assinatura será migrada para o plano {{getDowngradingPlanDescription()}} na próxima renovação.<b-button variant="danger" size="sm" class="ml-4" @click="cancelDowngrade">Cancelar</b-button></p>
            </div>
          </b-col>
        </b-row>
        <b-form-row>
          <b-col cols="8">
            <div class="box-cj mb-3">
              <div class="header">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="title">Escolha seu plano</p>

                  <div>
                    <a href="https://consultaja.com/#priceplanos" target="_blank"><small>Ver detalhes dos planos</small></a>
                  </div>
                </div>
              </div>
              <div class="content">
                <b-row>
                  <b-col cols="12" md="4" class="text-center" v-for="(plan, index) of plans" :key="index">
                    <div :class="'plan-option ' + (plan.plan == selectedPlan.plan ? 'active' : '')">
                      <img :src="getPlanImage(plan)" :alt="plan.name" class="plan-image"/>
                      <p class="mb-2">{{ plan.name }}</p>
                      <div v-if="helpers.plansWithTelehealth().indexOf(plan.plan) >= 0">
                        <label class="plan-input-label">De quantos minutos sua clínica precisará por mês?</label>
                        <validation-provider name="minutos de teleconsulta" :rules="{ required: true }" v-slot="{ errors }">
                          <b-input-group class="time-group">
                            <b-button-group size="sm">
                              <b-button @click="selectedTelehealthMinutes-=telehealthMinutes.pack_minutes" :disabled="selectedTelehealthMinutes == telehealthMinutes.pack_minutes" variant="primary"><i class="far fa-minus-circle"></i></b-button>
                            </b-button-group>
                            <b-form-input type="number" :value="selectedTelehealthMinutes" :min="telehealthMinutes.pack_minutes" :step="telehealthMinutes.pack_minutes" readonly class="minutes-input" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <b-button-group size="sm">
                              <b-button @click="selectedTelehealthMinutes+=telehealthMinutes.pack_minutes" variant="primary"><i class="far fa-plus-circle"></i></b-button>
                            </b-button-group>
                          </b-input-group>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                        <label class="cj-label mb-2">Corresponde a
                          {{ formatAppointmentsEquivalence(selectedTelehealthMinutes / (60*2)) }} consultas de 1h com 2 participantes</label>
                      </div>
                      <b-button :variant="(plan.plan == selectedPlan.plan ? 'outline-primary' : 'primary')" size="sm" class="select-plan-btn" @click="setSelectedPlan(plan)" :disabled="plan.plan == selectedPlan.plan" block>{{plan.plan == currentPlan.plan ? 'Plano atual' : (plan.plan == selectedPlan.plan ? 'Selecionado' : 'Selecionar plano')}}</b-button>
                    </div>
                  </b-col>
                  <b-col cols="12" v-if="client != null && selectedPlan != null && (selectedPlan.plan != currentPlan.plan || (helpers.plansWithTelehealth().indexOf(selectedPlan.plan) >= 0 && ((client.subscription == null && selectedTelehealthMinutes > telehealthMinutes.pack_minutes) || (client.subscription != null && selectedTelehealthMinutes != client.subscription.minutes))))">
                    <b-alert v-if="client.subscription != null && daysToEndSubscription >= 0" show variant="secondary" class="mt-3 mb-0 text-center">
                      <p class="plan-change-details" v-if="selectedPlan.plan > currentPlan.plan || (helpers.plansWithTelehealth().indexOf(selectedPlan.plan) >= 0 && selectedTelehealthMinutes > client.subscription.minutes)">Na sua próxima renovação será cobrado o valor adicional de R$ {{formatPrice((getPlanPrice(false) - getCurrentPlanPrice(false))/100.0)}}, referente a diferença de valores entre o seu planos atual e o seu novo plano escolhido no período da sua assinatura vigente.</p>
                      <p class="plan-change-details" v-else>O seu plano atual é válido até o dia {{ subscriptionValidUntil.format('DD/MM/YYYY') }}. Todas as funcionalidades serão mantidas até a próxima cobrança que será realizada no valor do modulo escolhido e seus adicionais.</p>
                      <b-button variant="success" @click="changePlan">Alterar plano</b-button>
                    </b-alert>
                    <b-alert v-else-if="client.subscription == null" show variant="secondary" class="mt-3 mb-0 text-center">
                      <p class="plan-change-details mb-0">Agora escolha o meio de pagamento abaixo para concluir a ativação do plano selecionado.</p>
                    </b-alert>
                  </b-col>
                </b-row>
              </div>
<!--              <div class="footer text-center" v-if="selectedPlan != null && (selectedPlan.plan != currentPlan.plan || (helpers.plansWithTelehealth().indexOf(selectedPlan.plan) >= 0 && selectedMinutes != client.subscription.minutes)) && daysToEndSubscription < 0">-->
<!--                <b-button variant="success" size="lg" @click="changePlan">Alterar plano</b-button>-->
<!--              </div>-->
            </div>
            <div class="box-cj">
              <div class="header">
                Dados de pagamento
              </div>
              <div class="content">
                <b-row class="mb-2">
                  <b-col>
                  </b-col>
                </b-row>
                <validation-observer ref="paymentForm" v-slot="{ invalid }" v-if="enablePaymentForm">
                  <b-row class="mb-2" v-if="client != null">
                    <b-col cols="12">
                      <p>Escolha o método de pagamento</p>
                    </b-col>
                    <b-col cols="12" md="4" class="mb-2 mb-md-0" v-if="creditCardEnabled">
                      <div :class="'payment-method' + (paymentForm.payment_method == 'credit' ? ' active' : '')" @click="setPaymentMethod('credit')">
                        <img src="@/assets/images/payment-method-card.svg" alt="Cartão de crédito" />
                        <span class="ml-1">Cartão de crédito</span>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4">
<!--                      Liberado 3 dias antes do vencimento, ou em qualquer data durante o mes de dezembro-->
                      <div :class="'payment-method' + (paymentForm.payment_method == 'boleto' ? ' active' : '') + (moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? '' : ' payment-method-disabled')" @click="moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? setPaymentMethod('boleto') : ''" v-b-tooltip.hover :title="moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? '' : ('O boleto ficará disponível a partir do dia ' + subscriptionValidUntil.clone().subtract(allowBoletoAndPixDaysBeforeSubscriptionEnd, 'days').format('DD/MM/YYYY') + '.')">
                        <img src="@/assets/images/payment-method-boleto.svg" alt="Boleto" />
                        <span class="ml-2">Boleto</span>
                      </div>
                    </b-col>
                    <b-col cols="12" md="4" v-if="moment().format('DD/MM/YYYY') !== '20/01/2025' && moment().format('DD/MM/YYYY') !== '21/01/2025'">
<!--                      Liberado 3 dias antes do vencimento, ou em qualquer data durante o mes de dezembro-->
                      <div :class="'payment-method' + (paymentForm.payment_method == 'pix' ? ' active' : '') + (moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? '' : ' payment-method-disabled')" @click="moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? setPaymentMethod('pix') : ''" v-b-tooltip.hover :title="moment().format('MM') === '12' || daysToEndSubscription <= allowBoletoAndPixDaysBeforeSubscriptionEnd ? '' : ('O Pix ficará disponível a partir do dia ' + subscriptionValidUntil.clone().subtract(allowBoletoAndPixDaysBeforeSubscriptionEnd, 'days').format('DD/MM/YYYY') + '.')">
                        <img src="@/assets/images/payment-method-pix.svg" alt="Pix" />
                        <span class="ml-2">Pix</span>
                      </div>
                    </b-col>
                    <b-col cols="12" v-if="paymentForm.payment_method == 'credit'">
                      <hr>
                      <div class="card-wrapper mt-4 mb-3">
                        <Card v-model="cardForm"></Card>
                      </div>
                      <b-row class="mb-2">
                        <b-col cols="6">
                          <label class="cj-label">Número do cartão</label>
                          <validation-provider name="número do cartão" :rules="{ required: true, cardNumber: true }" v-slot="{ errors }">
                            <b-form-input type="tel" name="number" v-model="cardForm.number" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="3">
                          <label class="cj-label">Válido até</label>
                          <validation-provider name="válido até" :rules="{ required: true, cardExpiry: true }" v-slot="{ errors }">
                            <b-form-input type="tel" name="expiry" v-model="cardForm.expiry" :class="{ 'error': errors.length > 0 }" v-mask="'##/##'" autocomplete="off" v-card-focus></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="3">
                          <label class="cj-label">CVC</label>
                          <validation-provider name="cvc" :rules="{ required: true, cardCvc: true }" v-slot="{ errors }">
                            <b-form-input type="tel" name="cvc" v-model="cardForm.cvc" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row class="mb-2">
                        <b-col>
                          <label class="cj-label">Nome no cartão</label>
                          <validation-provider name="nome no cartão" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" name="name" v-model="cardForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-card-focus></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="12" v-if="paymentForm.payment_method != null">
                      <hr>
                      <p>Dados do pagador</p>
                      <b-row class="mb-3">
                        <b-col>
                          <label class="cj-label">Nome / Razão social</label>
                          <validation-provider name="nome / razão social" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="paymentForm.name" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">E-mail</label>
                          <validation-provider name="e-mail" :rules="{ required: true, email: true }" v-slot="{ errors }">
                            <b-form-input type="email" v-model="paymentForm.email" :disabled="!canManage" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">CPF / CNPJ</label>
                          <validation-provider name="CPF / CNPJ" :rules="{ required: true, cpfOrCnpj: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="paymentForm.document" :disabled="!canManage" v-mask="['###.###.###-##', '##.###.###/####-##']" :class="{ 'error': errors.length > 0 }" ></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <p>Endereço de cobrança</p>
                      <b-row class="mb-2">
                        <b-col cols="3">
                          <label class="cj-label">CEP</label>
                          <validation-provider name="cep" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="paymentForm.address.zip_code" v-mask="'#####-###'" :class="{ 'error': errors.length > 0 }" :disabled="!canManage" v-on:blur="findCep(paymentForm.address.zip_code)"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col cols="7">
                          <label class="cj-label">Endereço</label>
                          <validation-provider name="endereço" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="paymentForm.address.address" ref="address" :disabled="!canManage" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Número</label>
                          <validation-provider name="número" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="tel" v-model="paymentForm.address.number" ref="number" :disabled="!canManage" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <label class="cj-label">Complemento</label>
                          <b-form-input type="text" v-model="paymentForm.address.complement" :disabled="!canManage"></b-form-input>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Bairro</label>
                          <validation-provider name="bairro" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="paymentForm.address.neighborhood" ref="neighborhood" :disabled="!canManage" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Cidade</label>
                          <validation-provider name="cidade" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="paymentForm.address.city" ref="city" :disabled="!canManage" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                        <b-col>
                          <label class="cj-label">Estado</label>
                          <validation-provider name="estado" :rules="{ required: true, length: 2 }" v-slot="{ errors }">
                            <b-form-input type="text" v-model="paymentForm.address.state" ref="state" :disabled="!canManage" :class="{ 'error': errors.length > 0 }"></b-form-input>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </validation-observer>
                <b-row class="mb-2" v-else-if="pendingInvoice != null">
                  <b-col v-if="pendingInvoice.payment_method == 'boleto'">
                    <b-row class="mb-2">
                      <b-col cols="6">
                        <label class="cj-label">Boleto</label>
                        <div class="w-100 d-flex align-items-center">
                          <img src="@/assets/images/boleto.svg" alt="Boleto" height="30px" class="mr-2"/>
                          <span class="mr-5">Gerado em {{ moment(pendingInvoice.created_at).format('DD/MM/YYYY') }}</span>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-3">
                      <b-col>
                        <label class="cj-label">Linha digitável</label>
                        <div class="w-100">
                          <span>{{ pendingInvoice.boleto_barcode }}</span>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-5">
                      <b-col>
                        <b-button variant="primary" size="lg" :href="pendingInvoice.boleto_url" target="_blank">Ver boleto</b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-if="canManage" class="text-center">
                        <span class="faded-text">A ativação da sua conta acontece mediante a compensação do Boleto, e pode demorar até 3 dias. Se deseja escolher outro meio de pagamento <a href="#" @click="deletePendingInvoice">clique aqui.</a></span>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col v-else>
                    <b-row class="mb-2">
                      <b-col cols="6">
                        <label class="cj-label">Pix</label>
                        <div class="w-100 d-flex align-items-center">
                          <img src="@/assets/images/payment-method-pix.svg" alt="Pix" height="30px" class="mr-2"/>
                          <span class="mr-5" v-if="pendingInvoice.pix_qr_code !== null">Válido até {{ moment(pendingInvoice.pix_valid_until).format('DD/MM/YY HH:mm') }}</span>
                          <span class="mr-5" v-else>Expirado</span>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-3" v-if="pendingInvoice.pix_qr_code !== null">
                      <b-col>
<!--                        <label class="cj-label"></label>-->
                        <p class="pix-qr-code-text text-center mb-2">Leia o QRCode abaixo no seu celular para realizar o pagamento</p>
                        <div class="w-100 text-center">
                          <qrcode-vue :value="pendingInvoice.pix_qr_code" size="250" level="H"></qrcode-vue>
                        </div>
                        <label class="cj-label">Pix copia e cola</label>
                        <div class="w-100">
                          <span class="pix-qr-code-text">
                            {{ pendingInvoice.pix_qr_code }}
<!--                            <b-button size="sm" @click="copyPixQrCode"><i class="far fa-copy"></i></b-button>-->
                            <b-form-textarea class="copyPixQrCodeTextArea" :value="pendingInvoice.pix_qr_code" ref="pixQrCode"></b-form-textarea>
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mb-5" v-if="pendingInvoice.pix_qr_code !== null">
                      <b-col>
                        <b-button variant="primary" size="lg" @click="copyPixQrCode">Copiar</b-button>
                      </b-col>
                    </b-row>
                    <b-row v-if="pendingInvoice.pix_qr_code !== null">
                      <b-col v-if="canManage" class="text-center">
                        <span class="faded-text">A ativação da sua conta acontece mediante a compensação do Pix, e pode demorar alguns minutos. Se deseja escolher outro meio de pagamento <a href="#" @click="deletePendingInvoice">clique aqui.</a></span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mb-2" v-else>
                  <b-col>
                    <b-row class="mb-4">
                      <b-col cols="6">
                        <label class="cj-label">Dados do cartão</label>
                        <div class="w-100 d-flex align-items-center">
                          <img :src="getCardBrandImage(client.subscription.card_brand)" height="30px" class="mr-2" :alt="client.subscription.card_brand" />
                          <span class="mr-5" v-if="client.subscription.payment_gateway == 'asaas'">**** **** **** {{ client.subscription.card_bin }}</span>
                          <span class="mr-5" v-else>{{ client.subscription.card_bin }} **** **** ****</span>
                        </div>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Válido até</label>
                        <div class="w-100">
                          <span>{{ moment(client.subscription.card_valid_until).format('MM/YYYY') }}</span>
                        </div>
                      </b-col>
                      <b-col v-if="canManage" cols="1" class="text-right">
                        <label class="cj-label d-block">&nbsp;</label>
                        <b-button variant="danger" @click="deleteCreditCard"><i class="far fa-trash-alt"></i></b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>

              <div class="footer" v-if="enablePaymentForm && paymentForm.payment_method != null">
                <b-alert v-if="client.subscription && client.subscription.upgrade_value_in_cents > 0 && (paymentForm.payment_method == 'boleto' || paymentForm.payment_method == 'pix' || daysToEndSubscription < 0)" show variant="warning" class="mb-3 text-center">
                  <p class="plan-change-details mb-0">Será cobrado o valor adicional de R$ {{formatPrice(client.subscription.upgrade_value_in_cents/100.0)}}, referente ao upgrade de plano.</p>
                </b-alert>
                <b-button variant="primary" class="mr-3" @click="makePayment()" v-if="(paymentForm.payment_method == 'boleto' || paymentForm.payment_method == 'pix' || daysToEndSubscription < 0)" block :disabled="!canManage || !canPerformAction">{{ paymentForm.payment_method == 'boleto' ? 'Gerar boleto' : (paymentForm.payment_method == 'pix' ? 'Gerar Pix' : 'Efetuar pagamento') }}</b-button>
                <b-button variant="primary" class="mr-3" @click="makePayment()" v-if="paymentForm.payment_method == 'credit' && daysToEndSubscription >= 0" block :disabled="!canManage || !canPerformAction">Salvar cartão</b-button>
                <b-row v-else>
<!--                  <b-col>-->
<!--                    <b-button variant="primary" @click="changePayment()" block>Alterar assinatura</b-button>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <b-button variant="danger" @click="cancelPayment()" block>Cancelar assinatura</b-button>-->
<!--                  </b-col>-->
                </b-row>
              </div>
            </div>
          </b-col>
          <b-col cols="4" v-if="selectedPlan != null">
            <div class="box-cj">
              <div class="header">
                Resumo do seu plano
              </div>
              <div class="content">
                <h4 class="plan-price mb-0">R$ {{ formatPrice(getPlanPrice(false)/100.0) }} / {{ subscriptionChargePeriods.find(g => g.value == (client != null ? client.subscription_charge_period : 1)).name }}</h4>
                <hr>
                <p>Módulos inclusos</p>
                <template v-for="(plan, index) of plans">
                  <div class="included-plan" :key="index" v-if="plan.plan == 0">{{index + 1}}. {{plan.name}}</div>
                  <div class="included-plan" :key="index" v-else-if="plan.plan == 1 && helpers.plansWithFullAdministration().indexOf(selectedPlan.plan) >= 0">{{index + 1}}. {{plan.name}}</div>
                  <div class="included-plan" :key="index" v-else-if="plan.plan == 2 && helpers.plansWithTelehealth().indexOf(selectedPlan.plan) >= 0">{{index + 1}}. {{plan.name}}</div>
                </template>
                <table class="table table-responsive w-100 d-block d-md-table table-cj mb-1">
                  <thead>
                  <tr>
                    <th class="py-1"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td class="text-right">R$ {{ formatPrice((selectedPlan.price_in_cents)/100.0) }}</td>
                  </tr>
                  </tbody>
                </table>

                <p class="mb-0">Adicionais</p>
                <table class="table table-responsive w-100 d-block d-md-table table-cj">
                  <thead>
                    <tr>
                      <th colspan="3" class="py-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{extraAgendas}}</td>
                      <td>Agendas Inteligentes</td>
                      <td class="text-right">R$ {{ formatPrice(extraAgendasPrice/100.0) }}</td>
                    </tr>
                    <tr>
                      <td>{{extraWhatsapps}}</td>
                      <td>Números de Whatsapp</td>
                      <td class="text-right">R$ {{ formatPrice(extraWhatsappsPrice/100.0) }}</td>
                    </tr>
                    <tr v-if="helpers.plansWithTelehealth().indexOf(selectedPlan.plan) >= 0">
                      <td>{{ (selectedTelehealthMinutes - telehealthMinutes.pack_minutes) }}</td>
                      <td>Minutos de teleconsultas</td>
                      <td class="text-right">R$
                        {{ formatPrice(getExtraTelehealthMinutesPrice(selectedTelehealthMinutes, false) / 100.0) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-form-row>
      </div>

      <div v-if="invoices.length > 0" class="box-container">
        <b-row>
          <b-col cols="12">
            <div class="box-cj">
              <div class="header">
                <div class="d-flex justify-content-between">
                  <p class="title">Pagamentos</p>
                </div>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table table-cj">
                  <thead>
                  <tr>
                    <th>Data</th>
                    <th>Método de pagamento</th>
                    <th>Valor</th>
                    <th>Identificador</th>
                    <th>Status</th>
                    <th>NFSe</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="invoice in invoices" :key="invoice.id">
                      <td>{{ moment(invoice.date).format('DD/MM/YYYY') }}</td>
                      <td>{{ formatPaymentMethod(invoice) }}</td>
                      <td>R$ {{ formatPrice(invoice.value_in_cents/100.0) }}<i class="fas fa-sm fa-info-circle ml-2 curiousBlue" v-if="invoice.notes != null" v-b-tooltip.hover :title="invoice.notes"></i></td>
                      <td>{{ invoice.payment_method == 'boleto' ? invoice.boleto_document_number : (invoice.payment_method == 'Pix' ? invoice.pix_id : (invoice.card_nsu != null ? (invoice.card_nsu + '-' + invoice.card_auth) : '')) }}</td>
                      <td>{{ invoiceStatusOptions.find(g => g.value == invoice.status).name }}</td>
                      <td>
                        <b-button v-if="invoice.nfse != null && (invoice.nfse.status == 'CANCELADO' || invoice.nfse.status == 'CONCLUIDO')" variant="primary" size="sm" block @click="downloadNfse(invoice.id, invoice.nfse.number)"><i class="far fa-download"></i></b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        leavingPage: false,
        showPlanDetails: true,
        client: null,
        user: null,
        pendingInvoice: null,
        interval: null,
        invoices: [],

        invoiceStatusOptions: [
          { value: 'new', name: 'Novo' },
          { value: 'pending', name: 'Pendente' },
          { value: 'pre_authorized', name: 'Pré-autorizado' },
          { value: 'succeeded', name: 'Pago' },
          { value: 'failed', name: 'Recusado' },
          { value: 'reversed', name: 'Revertido' },
          { value: 'canceled', name: 'Cancelado' },
          { value: 'refunded', name: 'Reembolsado' },
          { value: 'dispute', name: 'Em disputa' },
          { value: 'charged_back', name: 'Devolvido' }
        ],

        subscriptionChargePeriods: [
          { value: 1, name: 'mês' },
          { value: 2, name: 'bimestre' },
          { value: 3, name: 'trimestre' },
          { value: 6, name: 'semestre' },
          { value: 12, name: 'ano' }
        ],

        testUntil: this.moment(),
        subscriptionValidUntil: this.moment(),
        daysToEndTrial: 0,
        daysToEndSubscription: -1,
        allowBoletoAndPixDaysBeforeSubscriptionEnd: 3,
        automaticPaymentEnabled: false,
        agendasEnabled: 0,
        extraAgendas: 0,
        extraAgendasPrice: 0,
        whatsappsEnabled: 0,
        extraWhatsapps: 0,
        extraWhatsappsPrice: 0,
        priceInCents: 0,
        price: 0,

        plans: [],
        telehealthMinutes: null,

        currentPlan: null,
        selectedPlan: null,
        selectedTelehealthMinutes: 0,

        enablePaymentForm: true,
        // Cartao de credito ainda nao habilitado na conta Asaas; reativar via .env quando liberado
        creditCardEnabled: process.env.VUE_APP_CREDIT_CARD_ENABLED === 'true',

        canSee: true,
        canManage: true,
        canPerformAction: true,

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        cardForm: {
          number: '',
          brand: '',
          name: '',
          expiry: '',
          cvc: ''
        },

        paymentForm: {
          payment_method: null,

          name: '',
          email: '',
          document: '',

          address: {
            id: null,
            zip_code: '',
            address: '',
            number: '',
            complement: null,
            neighborhood: '',
            city: '',
            state: '',
            country: 'Brazil'
          }
        }
      }
    },
    mounted () {
      this.eventBus.$emit('IS_LOADING', true);

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('subscription', 'can_see');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('subscription', 'can_manage');

      if(!this.canSee) {
        this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
          this.eventBus.$emit('IS_LOADING', false);
          this.$router.push({ path: '/' }).catch(() => {});
        });
        return;
      }

      this.user = JSON.parse(localStorage.getItem('user'));

      this.api.getSubscription().then(res => {
        this.eventBus.$emit('IS_LOADING', false);
        if(this.leavingPage) {
          return;
        }
        this.client = res.data.client;
        this.pendingInvoice = res.data.pending_invoice;
        if(this.pendingInvoice && this.pendingInvoice.payment_method == 'pix') {
          this.interval = setInterval(this.checkPix, 15*1000);
        }
        this.invoices = res.data.subscription_invoices;
        if(this.client.subscription == null) {
          let unit = this.client.default_unit;
          if(unit.tax_info_enabled) {
            this.paymentForm.name = unit.company_name != null ? unit.company_name : unit.name;
            this.paymentForm.email = unit.email;
            this.paymentForm.document = unit.company_document != null ? unit.company_document : unit.document;
            this.paymentForm.address = unit.address;
          }
          else {
            this.paymentForm.name = unit.display_name;
            this.paymentForm.email = unit.display_email;
            this.paymentForm.document = unit.display_document;
            this.paymentForm.address = unit.display_address;
          }
        }
        else {
          this.paymentForm.name = this.client.subscription.name;
          this.paymentForm.email = this.client.subscription.email;
          this.paymentForm.document = this.client.subscription.document;
          this.paymentForm.address = this.client.subscription.address;
        }

        if(this.paymentForm.address == null) {
          this.paymentForm.address = {
            id: null,
            zip_code: '',
            address: '',
            number: '',
            complement: null,
            neighborhood: '',
            city: '',
            state: '',
            country: 'Brazil'
          };
        }

        this.agendasEnabled = this.client.agendas_count;
        this.extraAgendas = Math.max(this.agendasEnabled - 1, 0);
        this.extraAgendasPrice = res.data.plans.extra_agendas.price_in_cents;
        this.whatsappsEnabled = this.client.whatsapps_count;
        this.extraWhatsapps = Math.max(this.whatsappsEnabled - 1, 0);
        this.extraWhatsappsPrice = res.data.plans.extra_whatsapps.price_in_cents;
        this.priceInCents = res.data.price;
        this.price = this.priceInCents/100.0;

        this.plans = res.data.plans.plans;
        this.telehealthMinutes = res.data.plans.telehealth_minutes;

        let currentClientPlan = 2;
        if(this.client.subscription != null) {
          currentClientPlan = this.client.subscription.plan;
        }
        else if(this.user.person.client.mandic_campaign) {
          currentClientPlan = this.user.person.client.mandic_campaign.default_plan;
        }
        this.currentPlan = this.plans.find(d => d.plan == currentClientPlan);
        let isDowngradingPlan = this.isDowngradingPlan();
        this.selectedPlan = isDowngradingPlan ? this.getDowngradingPlan() : this.currentPlan;
        this.selectedTelehealthMinutes = isDowngradingPlan ? Math.max(this.getDowngradingMinutes(), this.telehealthMinutes.pack_minutes) : (this.client.subscription != null && this.client.subscription.minutes > 0 ? this.client.subscription.minutes : this.telehealthMinutes.pack_minutes);

        this.testUntil = this.moment(this.client.created_at).add(7, 'days').endOf('day');
        this.daysToEndTrial = this.testUntil.diff(this.moment().endOf('day'), 'days', true);
        this.daysToEndTrial = this.daysToEndTrial >= 0 ? Math.ceil(this.daysToEndTrial) : Math.floor(this.daysToEndTrial);
        if(this.client.allow_boleto_pix_days_before_subscription_end) {
          this.allowBoletoAndPixDaysBeforeSubscriptionEnd = this.client.allow_boleto_pix_days_before_subscription_end;
        }

        if(this.pendingInvoice != null) {
          this.enablePaymentForm = false;
        }
        if(this.client.subscription != null && this.client.subscription.status == 'ACTIVE') {
          this.subscriptionValidUntil = this.moment(this.client.subscription.valid_until).endOf('day');
          this.daysToEndSubscription = this.subscriptionValidUntil.diff(this.moment().endOf('day'), 'days', true);
          this.daysToEndSubscription = this.daysToEndSubscription >= 0 ? Math.ceil(this.daysToEndSubscription) : Math.floor(this.daysToEndSubscription);
          if(this.client.subscription.card_bin != null) {
            this.automaticPaymentEnabled = true;
            this.enablePaymentForm = false;
          }
        }
        this.showPlanDetails = this.enablePaymentForm;

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Get Subscription', res);
      }).catch(err => {
        this.canPerformAction = true;
        if(this.leavingPage) {
          return;
        }
        try {
          let response = err.response;
          if(response.status == 401) {
            this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
              this.$router.push({ path: '/' }).catch(() => {});
            });
          }
          else {
            this.$swal('Ops...', 'Não conseguimos carregar sua assinatura! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          }
        } catch(err2) {
          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchGetSubscription\nError:'+err.toString(), 'warning');
          this.sentry.captureException(err);
        }
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Get Subscription', err.response);
      });
    },
    methods: {
      getExtraTelehealthMinutesPrice(minutes, defaultPrice) {
        if(minutes <= this.telehealthMinutes.pack_minutes) {
          return 0;
        }
        let extraMinutes = minutes - this.telehealthMinutes.pack_minutes;
        return (extraMinutes/this.telehealthMinutes.pack_minutes) * (defaultPrice ? this.telehealthMinutes.default_price_in_cents : this.telehealthMinutes.price_in_cents);
      },

      getPlanPrice(defaultPrice) {
        let priceInCents = defaultPrice ? this.selectedPlan.default_price_in_cents : this.selectedPlan.price_in_cents;
        priceInCents += this.extraAgendasPrice + this.extraWhatsappsPrice;
        if(this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0) {
          priceInCents += this.getExtraTelehealthMinutesPrice(this.selectedTelehealthMinutes, defaultPrice);
        }
        return priceInCents;
      },

      getCurrentPlanPrice(defaultPrice) {
        let priceInCents = defaultPrice ? this.currentPlan.default_price_in_cents : this.currentPlan.price_in_cents;
        priceInCents += this.extraAgendasPrice + this.extraWhatsappsPrice;
        if(this.helpers.plansWithTelehealth().indexOf(this.currentPlan.plan) >= 0 && this.client.subscription != null) {
          priceInCents += this.getExtraTelehealthMinutesPrice(this.client.subscription.minutes, defaultPrice);
        }
        return priceInCents;
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      formatPaymentMethod(invoice) {
        if(invoice.payment_method == 'boleto') return 'Boleto';
        if(invoice.payment_method == 'pix') return 'Pix';
        if(invoice.card_brand != null && invoice.card_brand != '') {
          // Asaas grava os ultimos 4 do cartao (card_bin); Zoop (historico) gravava os 4 primeiros.
          return invoice.payment_gateway == 'asaas'
            ? invoice.card_brand + ' **** ' + invoice.card_bin
            : invoice.card_brand + ' ' + invoice.card_bin + ' ****';
        }
        return invoice.payment_method == 'debit' ? 'Débito' : 'Crédito';
      },

      formatAppointmentsEquivalence(value) {
        return Math.floor(value);
        // let val = Math.round(value * 100) / 100;
        // return val.toString().replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      getPlanImage(plan) {
        return require('../../assets/images/plan-'+plan.plan+'.png');
      },

      getDowngradingPlan() {
        let newPlan = parseInt(this.client.subscription.migrating_to_plan.split('=>')[1]);
        return this.plans.find(d => d.plan == newPlan);
      },

      getDowngradingMinutes() {
        return parseInt(this.client.subscription.migrating_to_minutes.split('=>')[1]);
      },

      isDowngradingPlan() {
        if(this.client == null || this.client.subscription == null || this.client.subscription.migrating_to_plan == null) {
          return false;
        }
        let newPlan = this.getDowngradingPlan(),
            newMinutes = this.getDowngradingMinutes();
        return this.currentPlan.plan > newPlan.plan || (this.helpers.plansWithTelehealth().indexOf(this.currentPlan.plan) >= 0 && this.client.subscription.minutes > newMinutes);
      },

      getDowngradingPlanDescription() {
        let newPlan = this.getDowngradingPlan(),
            newMinutes = this.getDowngradingMinutes();

        return newPlan.name + (this.helpers.plansWithTelehealth().indexOf(newPlan.plan) >= 0 ? (', com ' + newMinutes + ' minutos de teleconsultas por mês,') : '');
      },

      getCardBrandImage(brand) {
        return require('../../assets/images/'+brand.replace(/ /g, '').toLowerCase()+'.svg');
      },

      async downloadNfse(invoiceId, nfseNumber) {
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.api.getInvoiceNfse(invoiceId).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.downloadFile(res.data, 'nfse_' + nfseNumber + '.pdf')


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Download Nfse', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;
          if(response.status == 401) {
            this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
              this.$router.push({ path: '/' }).catch(() => {});
            });
          }
          else {
            let message = 'Não conseguimos baixar a nota fiscal! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
            switch (response.status) {
              case 422: message = response.data.errors.join('\r\n'); break;
              case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
            }

            this.$swal('Ops...', message, 'error');
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Download Nfse', err);
        });
      },

      downloadFile(fileData, fileName) {
        var blob = new Blob([fileData], {type: 'application/pdf'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob);
          return;
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = data;
        link.download = fileName;
        link.click();
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
        }, 100);
      },

      async makePayment() {
        const isValid = await this.$refs.paymentForm.validate();
        if(!isValid) {
          return false;
        }

        let isChangingPlan = this.selectedPlan.plan != this.currentPlan.plan || (this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0 && ((this.client.subscription == null && this.selectedTelehealthMinutes > this.telehealthMinutes.pack_minutes) || (this.client.subscription != null && this.selectedTelehealthMinutes != this.client.subscription.minutes))),
          confirmedOperation = true;
        if(isChangingPlan) {
          confirmedOperation = false;
          let isUpgrading = this.selectedPlan.plan > this.currentPlan.plan || (this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0 && ((this.client.subscription == null && this.selectedTelehealthMinutes > this.telehealthMinutes.pack_minutes) || (this.client.subscription != null && this.selectedTelehealthMinutes > this.client.subscription.minutes))),
              confirmationMessage = (isUpgrading ? 'Você esta prestes a fazer a migração para um plano superior, realizar essa mudança irá adicionar funcionalidades ao seu painel e sua assinatura mudará de valor' :
                  'Você esta optando por um plano inferior, realizar essa mudança irá bloquear funcionalidades que você utiliza atualmente.');

          if(isUpgrading) {
            confirmationMessage += (this.client.subscription == null || this.paymentForm.payment_method == 'boleto' || this.paymentForm.payment_method == 'pix' || this.daysToEndSubscription < 0) ? '.' : ' nas próximas cobranças.';
          }

          await this.$swal({
            title: 'Você tem certeza?',
            text: confirmationMessage,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              confirmedOperation = true;
            }
          });
        }
        if(!confirmedOperation) {
          return false;
        }

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        let paymentData = this.paymentForm;
        paymentData.plan = this.selectedPlan.plan;
        paymentData.minutes = this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0 ? this.selectedTelehealthMinutes : 0;

        if(this.paymentForm.payment_method == 'boleto' || this.paymentForm.payment_method == 'pix') {
          this.api.makeSubscriptionPayment(paymentData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.$router.go();
            // this.$swal('Uhull \\o/', 'Seu boleto foi gerado com sucesso!', 'success').then(() => {
            //   this.$router.go();
            // });

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Make Boleto/Pix Payment', res);
          }).catch(err => {
            try {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              if(response.status == 401) {
                this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                  this.$router.push({ path: '/' }).catch(() => {});
                });
              }
              else {
                let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
                switch (response.status) {
                  case 422: message = response.data.errors.join('\r\n'); break;
                  case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
                }

                this.$swal('Ops...', message, 'error');
              }
            } catch(err2) {
              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchMakeSubscriptionPayment\nError:'+err.toString(), 'warning');
              this.sentry.captureException(err);
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Make Boleto/Pix Payment', err);
          });
        }
        else {
          // Tokenizacao server-side no Asaas: enviamos os dados crus do cartao + dados do titular;
          // o backend tokeniza e cobra. (Antes: tokenizacao JS direto na API da Zoop pelo browser.)
          let expiryParts = this.cardForm.expiry.split('/');
          paymentData.credit_card = {
            holderName: this.cardForm.name,
            number: this.cardForm.number.replace(/\D/g, ''),
            expiryMonth: expiryParts[0].trim(),
            expiryYear: '20' + expiryParts[1].trim(),   // mascara MM/AA -> Asaas exige AAAA (4 digitos)
            ccv: this.cardForm.cvc
          };
          paymentData.credit_card_holder_info = {
            name: this.paymentForm.name,
            email: this.paymentForm.email,
            cpfCnpj: this.paymentForm.document.replace(/\D/g, ''),
            postalCode: this.paymentForm.address.zip_code.replace(/\D/g, ''),
            addressNumber: this.paymentForm.address.number
          };
          paymentData.make_payment = this.daysToEndSubscription < 0 ? 1 : 0;
          this.api.makeSubscriptionPayment(paymentData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.$router.go();

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Make Payment Card', res);
          }).catch(err => {
            try {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              if(response.status == 401) {
                this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                  this.$router.push({ path: '/' }).catch(() => {});
                });
              }
              else {
                // O backend Asaas ja devolve 400 com mensagem amigavel de recusa em response.data.message.
                let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
                switch (response.status) {
                  case 422: message = response.data.errors.join('\r\n'); break;
                  case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
                }

                this.$swal('Ops...', message, 'error');
              }
            } catch(err2) {
              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchMakeSubscriptionPayment\nError:'+err.toString(), 'warning');
              this.sentry.captureException(err);
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Make Payment Card', err);
          });
        }
      },

      // cancelPayment() {
      //   this.$swal({
      //     title: 'Você tem certeza que deseja cancelar a sua assinatura?',
      //     text: 'Ao cancelar você perderá acesso a suas informações.',
      //     type: 'warning',
      //     showCancelButton: true,
      //     confirmButtonText: 'Sim, vamos cancelar!',
      //     cancelButtonText: 'Não, vou manter meu plano!',
      //     focusCancel: true
      //   }).then((res) => {
      //     if (res.value) {
      //       this.api.cancelPayment().then(res => {
      //         this.$swal('Sucesso', 'Sua assinatura foi cancelada com sucesso!', 'success');
      //         window.location.reload();
      //
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Response Cancel Payment', res);
      //       }).catch(err => {
      //         this.$swal('Ops...', 'Não conseguimos cancelar esta assinatura! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
      //
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Error Cancel Payment', err.response);
      //       });
      //     }
      //   });
      // },

      deletePendingInvoice() {
        this.$swal({
          title: 'Você tem certeza?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Trocar meio de pagamento',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deletePendingInvoice(this.pendingInvoice.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$router.go();
              // this.$swal('Sucesso', 'Seu boleto foi excluído com sucesso!', 'success').then(() => {
              //   this.$router.go();
              // });

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Boleto/Pix', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              if(response.status == 401) {
                this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                  this.$router.push({ path: '/' }).catch(() => {});
                });
              }
              else {
                let message = 'Não conseguimos excluir este ' + this.pendingInvoice.payment_method + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
                switch (response.status) {
                  case 422: message = response.data.errors.join('\r\n'); break;
                  case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
                }

                this.$swal('Ops...', message, 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Boleto/Pix', err.response);
            });
          }
        });
      },

      deleteCreditCard() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir cartão',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deleteCreditCard(this.client.subscription.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$router.go();
              // this.$swal('Sucesso', 'Seu cartão foi excluído com sucesso!', 'success').then(() => {
              //   this.$router.go();
              // });

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Credit Card', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let response = err.response;
              if(response.status == 401) {
                this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                  this.$router.push({ path: '/' }).catch(() => {});
                });
              }
              else {
                let message = 'Não conseguimos excluir este cartão! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
                switch (response.status) {
                  case 422: message = response.data.errors.join('\r\n'); break;
                  case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
                }

                this.$swal('Ops...', message, 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Credit Card', err.response);
            });
          }
        });
      },

      setSelectedPlan(plan) {
        this.selectedPlan = plan;
      },

      async changePlan() {
        if(this.selectedPlan.plan == this.currentPlan.plan && (this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) < 0 || this.selectedTelehealthMinutes == this.client.subscription.minutes)) {
          this.$swal('Ops...', 'Você não fez nenhuma alteração no seu plano.', 'error')
          return;
        }

        let isUpgrading = this.selectedPlan.plan > this.currentPlan.plan || (this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0 && this.selectedTelehealthMinutes > this.client.subscription.minutes),
            confirmationMessage = (isUpgrading ? 'Você esta prestes a fazer a migração para um plano superior, realizar essa mudança irá adicionar funcionalidades ao seu painel e sua assinatura mudará de valor nas próximas cobranças.' :
                'Você esta optando por um plano inferior, realizar essa mudança irá bloquear funcionalidades que você utiliza atualmente.'),
            doChangePlan = false;

        await this.$swal({
          title: 'Você tem certeza?',
          text: confirmationMessage,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            doChangePlan = true;
          }
        });

        if(doChangePlan) {
          this.canPerformAction = false;
          this.eventBus.$emit('IS_LOADING', true);
          let planData = {
            plan: this.selectedPlan.plan,
            minutes: this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) >= 0 ? this.selectedTelehealthMinutes : 0
          }

          this.api.changeSubscriptionPlan(planData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.$swal('Uhull \\o/', 'Seu plano foi atualizado com sucesso!', 'success').then(() => {
              this.$router.go();
            });

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Change Subscription Plan', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' }).catch(() => {});
              });
            }
            else {
              let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Change Subscription Plan', err);
          });
        }
      },

      async cancelDowngrade() {
        if(this.selectedPlan.plan == this.currentPlan.plan && (this.helpers.plansWithTelehealth().indexOf(this.selectedPlan.plan) < 0 || this.selectedTelehealthMinutes == this.client.subscription.minutes)) {
          this.$swal('Ops...', 'Você não fez nenhuma alteração no seu plano.', 'error')
          return;
        }

        let doCancelDowngrade = false;

        await this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            doCancelDowngrade = true;
          }
        });

        if(doCancelDowngrade) {
          this.canPerformAction = false;
          this.eventBus.$emit('IS_LOADING', true);

          this.api.cancelSubscriptionDowngrade().then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            this.$router.go();

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Change Subscription Plan', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let response = err.response;
            if(response.status == 401) {
              this.$swal('Ops...', 'Você não tem permissão para acessar este módulo!', 'error').then(() => {
                this.$router.push({ path: '/' }).catch(() => {});
              });
            }
            else {
              let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
              switch (response.status) {
                case 422: message = response.data.errors.join('\r\n'); break;
                case 400: message = typeof response.data.message != 'undefined' && response.data.message != '' ? response.data.message : message; break;
              }

              this.$swal('Ops...', message, 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Cancel Subscription Downgrade', err);
          });
        }
      },

      setPaymentMethod(method) {
        this.paymentForm.payment_method = method;
      },

      showFullPlanDetails() {
        this.showPlanDetails = true;
      },

      findCep(value) {
        if(value.length == 9) {
          axios.get('https://viacep.com.br/ws/'+value+'/json/').then(res => {
            if(typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.paymentForm.address.address = cepData.logradouro;
              this.paymentForm.address.neighborhood = cepData.bairro;
              this.paymentForm.address.city = cepData.localidade;
              this.paymentForm.address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {

              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      async checkPix() {
        this.api.checkPixInvoice().then(res => {
          let invoiceData = res.data.invoice;
          if(invoiceData == null) {
            this.$swal('Ops...', 'O Pix expirou.', 'warning').then(() => {
              this.$router.go();
            });
          }
          else if(invoiceData.status == 'PAID') {
            this.$swal('Uhull \\o/', 'Seu pagamento foi aprovado!', 'success').then(() => {
              this.$router.go();
            });
          }
          else {
            this.pendingInvoice = invoiceData;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Pix Invoice', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;

          let message = 'Não conseguimos validar os seus dados! Verifique as informações digitadas e tente novamente.';
          switch (response.status) {
            case 422: message = response.data.errors.join('\r\n'); break;
            case 400:  {
              if(typeof response.data.message != 'undefined' && response.data.message != '') {
                if(response.data.message.indexOf('service_request_timeout:') >= 0) {
                  message = 'O serviço de pagamento está temporariamente indisponível. Por favor, aguarde um momento e tente novamente.';
                }
                else {
                  message = response.data.message;
                }
              }
              break;
            }
          }
          let reload = response.data.reload;
          this.$swal('Ops...', message, 'error').then(() => {
            if(reload) {
              this.$router.go();
            }
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Pix Invoice', err);
        });
      },

      copyPixQrCode() {
        this.$refs.pixQrCode.select();
        document.execCommand('copy');
        this.$swal('Uhull \\o/', 'Copiado com sucesso!', 'success');
      }
    },
    beforeRouteLeave (to, from, next) {
      if(this.interval != null) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .subscription {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }

    .plan-option {
      height: 100%;
      border: 1px solid $mystic;
      border-radius: 4px;
      padding: 10px;
      color: $blueBayoux;
      display: flex;
      flex-direction: column;

      &:hover {
        border-color: $columbiaBlue;
      }

      &.active {
        border-color: $curiousBlue;
      }

      .plan-image {
        height: 65px;
        width: auto;
        margin: 0 auto 10px;
      }

      .plan-input-label {
        //font-family: 'sf_pro_displayregular';
        font-size: 13px;
        margin-bottom: 2px;
        color: $cadetGray;
      }

      .select-plan-btn {
        margin-top: auto;
      }
    }
    .plan-change-details {
      font-family: 'sf_pro_displayregular';
    }

    .payment-method {
      border: 1px solid $mystic;
      border-radius: 4px;
      padding: 10px;
      color: $blueBayoux;
      cursor: pointer;

      img {
        height: 26px;
      }

      &:hover {
        border-color: $columbiaBlue;
      }

      &.active {
        border-color: $curiousBlue;
      }

      &.payment-method-disabled {
        color: $cadetGray;
        cursor: not-allowed;

        img {
          filter: grayscale(100%);
        }
      }
    }

    .plan-price {
      font-family: 'sf_pro_displaymedium';
      text-align: center;
      padding-top: 8px;
      width: 100%;
      color: $dullLime;
    }

    .included-plan {
      font-family: 'sf_pro_displaymedium';
      font-size: 15px;
      color: $blueBayoux;
    }

    //.plan {
    //  margin-bottom: 0;
    //
    //  > li {
    //    display: flex;
    //    justify-content: space-between;
    //    border-bottom: 1px solid $mystic;
    //    padding: 14px;
    //
    //    font-family: 'sf_pro_displayregular';
    //    color: $cadetGray;
    //
    //    &
    //    }
    //
    //    &:last-child {
    //      border-bottom: 0;
    //    }
    //  }
    //}

    .striked-text {
      text-decoration: line-through;
    }

    .faded-text {
      font-family: 'sf_pro_displayregular';
      font-size: 15px;
      color: $cadetGray;
    }

    .copyPixQrCodeTextArea {
      width: 1px;
      height: 1px;
      padding: 0;
      opacity: 0;
    }
  }

  .minutes-input {
    background-color: #fff!important;
    pointer-events: none;
  }

  .pix-qr-code-text {
    font-size: .9rem;
  }
</style>
